<template>
  <v-card class="pa-4" flat>
    <v-form>
      <v-row justify="start">
        <v-col cols="12" xs="12">
          <v-row>
            <v-col cols="8"  class="py-0 pb-4"  v-if="formData.typ === 1">
              <span class="headline">Veranstalter</span>
            </v-col>
            <v-col cols="4" class="py-0" v-if="false">
              <v-checkbox outlined v-model="formData.isMother" class="mx-2" label="Netzwerk"></v-checkbox>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-text-field
              label="Name"
              clearable
              outlined
              dense
              v-model="formData.name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-select
              v-model="formData.tags"
              :items="formData.tags"
              outlined
              dense
              chips
              value="fred"
              deletable-chips
              small-chips
              label="Gruppe"
              multiple
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
              label="Gruppe"
              :items="tagList"
              clearable
              dense
              outlined
              ref="acFields"
              @keyup.enter.native="onEnterTag"
              v-model="tagac"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                  label="Straße"
                  clearable
                  outlined
                  dense
                  v-model="formData.street"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-text-field
                  label="PLZ"
                  outlined
                  clearable
                  dense
                  v-model="formData.postcode"
              ></v-text-field>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-text-field
              label="Ort"
              dense
              clearable
              outlined
              v-model="formData.city"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  label="Ansprechpartner"
                  clearable
                  dense
                  outlined
                  v-model="formData.contactPerson"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="Telefon"
                  clearable
                  dense
                  outlined
                  v-model="formData.phonenumber"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                  label="E-Mail"
                  outlined
                  dense
                  clearable
                  v-model="formData.email"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  label="Agency Id"
                  outlined
                  dense
                  clearable
                  v-model="formData.advisoryId"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                  v-model="formData.templateId"
                  :items="templates"
                  item-text="name"
                  item-value="guid"
                  outlined
                  dense
                  label="Template"
              ></v-select>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-checkbox outlined v-model="formData.legacy" class="mx-2" label="Legacy"></v-checkbox>
            </v-col>

            <v-col cols="1" v-if="false">
              <v-btn @click="openax()">Test</v-btn>
            </v-col>
            <v-col cols="12">
              <v-textarea
              label="Anmerkung"
              clearable
              dense
              outlined
              v-model="formData.comment"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
              erstellt am {{formData.created}}
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="12" class="py-0 text-right">
              <v-btn @click="cancelItem()" color="grey" class="text-none mr-8" outlined>Abbrechen</v-btn>
              <v-btn @click="updateItem()" color="primary" class="text-none ml-4">Speichern</v-btn>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TabDefault',
  components: {},
  props: {
    formData: Object,
    companyId: String,
    tagList: Array
  },
  methods: {
    openax: function() {
      // Vue.prototype.$config.HOST
      // offerId=161791303&advisoryId=NYZN-0275&code=ff1ce4a238fabef95fe34f2fb6ebbb24
      const url = 'http://192.168.5.181:8080/#/pc/addImage?offerId=161791303&advisoryId=NYZN-0275&code=0815'
      window.open(url,'_new')
      this.$router.push()
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
    },
    onEnterTag: function () {
      this.formData.tags.push(this.$refs.acFields.internalSearch)
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Netzwerke')
    },
    updateItem: function () {
      Vue.prototype.$apiCompany.updateCompany(this.companyId, this.formData, this.onItemUpdated)
    },
    onGetTemplates: function (data) {
      this.templates = data
    }
  },
  data () {
    return {
      tag: '',
      tagac: '',
      tags: [],
      templates: []
    }
  },
  mounted () {
    Vue.prototype.$apiTemplate.load({}, this.onGetTemplates)
  }
}
</script>

<style scoped>

</style>
